const translationTypes = {
  GET_LANGUAGE_START: 'GET_LANGUAGE_START',
  GET_LANGUAGE_SUCCESS: 'GET_LANGUAGE_SUCCESS',
  GET_LANGUAGE_FAIL: 'GET_LANGUAGE_FAIL',

  GET_TRANSLATIONS_START: 'GET_TRANSLATIONS_START',
  GET_TRANSLATIONS_SUCCESS: 'GET_TRANSLATIONS_SUCCESS',
  GET_TRANSLATIONS_FAIL: 'GET_TRANSLATIONS_FAIL',

  SET_LANGUAGE: 'SET_LANGUAGE',
};

export default translationTypes;
